// use-eve-portfolio — React-Wrapper für das virtuelle Trading-Portfolio.
// V1-Pendant: src/hooks/useEvePortfolio.js (Module-level Funktionen über localStorage).
//
// V3-Refactor: Zustand-Store + pure lib. ensureInitialized läuft beim Mount
// und migriert V1-Altdaten ($10k → $500k).

import { useEffect, useMemo } from 'react';
import { formatPortfolioForPrompt, getRecommendedCapital } from '@/lib/portfolio';
import { selectPortfolio, usePortfolioStore } from '@/stores/portfolio-store';
import type { PortfolioState } from '@/types/portfolio';

export interface UseEvePortfolioReturn {
  portfolio: PortfolioState;
  /** 2% des current capital — Empfehlung für nächsten Trade. */
  recommendedCapital: number;
  /** Vorformatierter Block für EVE-System-Prompt. */
  promptBlock: string;
  applyTrade: (pnlAbsolute: number) => PortfolioState;
  reset: () => PortfolioState;
}

export function useEvePortfolio(): UseEvePortfolioReturn {
  const portfolio = usePortfolioStore(selectPortfolio);
  const ensureInitialized = usePortfolioStore((s) => s.ensureInitialized);
  const applyTrade = usePortfolioStore((s) => s.applyTrade);
  const reset = usePortfolioStore((s) => s.reset);

  // Mount-Effect: V1-Migration prüfen
  useEffect(() => {
    ensureInitialized();
  }, [ensureInitialized]);

  const recommendedCapital = useMemo(() => getRecommendedCapital(portfolio), [portfolio]);
  const promptBlock = useMemo(() => formatPortfolioForPrompt(portfolio), [portfolio]);

  return { portfolio, recommendedCapital, promptBlock, applyTrade, reset };
}
